import React, { useState, useEffect, useRef } from 'react'
import Masonry from 'react-masonry-css'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
// import Inline from "yet-another-react-lightbox/plugins/inline";
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import 'yet-another-react-lightbox/styles.css'
import '../../../styles/GalleryPhotos.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import { Link as LinkRouter } from 'react-router-dom'
import { ReactComponent as Crossclose } from '../../../assets/icones/cross-close.svg'

function GalleryPhotos() {
  const [isloading, setIsLoading] = useState(false)
  const [listephotos, setListePhotos] = useState([])
  // const [melange, setMelange] = useState([]);
  const [indexphoto, setIndexPhoto] = useState(-1)
  const breakpointColumnsObj = {
    default: 5,
    1100: 2,
    500: 1,
  }
  //   const zoomRef = useRef(null);

  // Fonction de mélange utilisant l'algorithme de Fisher-Yates
  function shuffleArray(array) {
    const shuffledArray = [...array]
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ]
    }
    return shuffledArray
  }

  useEffect(() => {
    // Chargez les données à partir du fichier JSON
    fetch('./json/ImagesGalerieDuodanse.json')
      .then((response) => response.json())
      .then((data) => {
        setListePhotos(shuffleArray(data))
        setIsLoading(true)
      })
      .catch((error) =>
        console.error('Erreur lors du chargement des photos:', error)
      )
  }, [])

  const slides = listephotos.map(({ srcBig, id }) => ({
    id: id,
    src: srcBig,
  }))

  const thumbnailsRef = useRef(null)
  if (isloading) {
    return (
      <div className="gallery">
        <Lightbox
          open={indexphoto >= 0}
          index={indexphoto}
          close={() => {
            setIndexPhoto(-1)
          }}
          slides={slides}
          plugins={[Thumbnails, Zoom]}
          thumbnails={{ ref: thumbnailsRef }}
          on={{
            click: () => {
              ;(thumbnailsRef.current?.visible
                ? thumbnailsRef.current?.hide
                : thumbnailsRef.current?.show)?.()
            },
          }}
          // animation={{ zoom: animationDuration }}
          // zoom={{
          // maxZoomPixelRatio,
          // zoomInMultiplier,
          // doubleTapDelay,
          // doubleClickDelay,
          // doubleClickMaxStops,
          // keyboardMoveDistance,
          // wheelZoomDistanceFactor,
          // pinchZoomDistanceFactor,
          // scrollToZoom,
          // }}
          animation={500}
          zoom={[1, 2, 300, 300, 2, 50, 100, 100, false]}
        />
        <div className="titreGallery">
          <img
            src="./images/galerie-duodanse/EnTeteDuoDanse.png"
            alt="DUO DANSE"
          />
          <LinkRouter to="/" id="pageP" className="btretourphotos">
            <img src="./images/icones/cross-close-white.svg" alt="" />
            <Crossclose />
          </LinkRouter>
        </div>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {listephotos.map((photo, index) => (
            <div
              key={index}
              href={photo.src}
              data-src={photo.srcBig}
              data-sub-html={`<h4>${photo.title}</h4>`}
              className="masonry-item"
            >
              <img
                src={photo.src}
                alt={photo.title}
                className="masonry-image"
                onClick={() => {
                  setIndexPhoto(index)
                }}
              />
            </div>
          ))}
        </Masonry>
      </div>
    )
  }
}

export default GalleryPhotos
